<template>
  <div class="carrot">
    <div class="main-wrapper">
      <Menu></Menu>
      <pop-channel-add :visible="popVisible" @close="popClose"/>
      <div class="page-wrapper">
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">픽포유 관리</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="clear mb-2">
                    <div class="form-group float-left clear w-100per">
                      <span style="font-weight: bold; cursor: pointer; font-size: 20px" @click="$router.push('/pick4u')">채널 리스트</span>
                      <span> | </span>
                      <span style="cursor: pointer; font-size: 20px" @click="$router.push('/pick4uVideo')">영상 리스트</span>
                    </div>
                    <div class="form-group float-left clear w-100per">
                      <table class="table table-bordered">
                        <tr>
                          <th>등록 날짜</th>
                          <td colspan="3">
                            <input v-model="filter.sdate" type="date"> - <input v-model="filter.edate" type="date">
                          </td>
                        </tr>
                        <tr>
                          <th>채널 이름</th>
                          <td><input v-model="filter.channelName" type="text"></td>
                          <th>채널 ID</th>
                          <td><input v-model="filter.channelId" type="text"></td>
                        </tr>
                      </table>
                    </div>
                    <div>
                      <button class="btn btn-primary fr ml-10" @click="selectChannels()">검색</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <button class="btn btn-primary fr ml-10 mb-3" @click="popVisible = true">등록</button>
                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                    <table class="table table-bordered">
                      <tbody>
                      <tr align="center" height="25">
                        <th width="50" class="table02">No</th>
                        <th width="100" class="table02">채널 ID</th>
                        <th>채널 이름</th>
                        <th width="100" class="table02">수집 영상 개수</th>
                        <th>등록 날짜</th>
                        <th width="10" class="table02">최근 수집일</th>
                        <th width="100" class="table02">삭제</th>
                      </tr>

                      <tr style="" v-for="(channel, index) in this.channels" :key="index" align="center" height="25">
                        <td>{{ (result.total - (result.currentPage - 1) * result.perPage  ) - index }}</td>
                        <td><a href="#" @click="goOtherPage('/pick4u/' + channel.channel_id)">{{ channel.channel_id }}</a></td>
                        <td>{{ channel.channel_title }}</td>
                        <td>{{ channel.count_video }}</td>
                        <td>{{ channel.create_date }}</td>
                        <td>{{ channel.current_create_date }}</td>
                        <td><button @click="deleteChannel(channel.channel_id)">삭제</button></td>
                      </tr>
                      <tr v-if="this.channels.length <= 0" >
                        <td colspan="10">
                          검색결과가 존재하지 않습니다.
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="this.channels.length !== 0" style="padding-left:40%; padding-top:20px;">
                    <paginate :page-count="lastpage" :page-range="3" :margin-pages="2"
                              :click-handler="clickCallback" :prev-text="'Prev'"
                              :next-text="'Next'" :container-class="'pagination'"
                              :page-class="'page-link'">
                    </paginate>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '../../components/commons/incMenu'
import Paginate from 'vuejs-paginate';
import popChannelAdd from '../../components/popChannelAdd'

export default {
  name: 'Pick4u',
  components: {
    Menu,
    Paginate,
    popChannelAdd
  },
  data () {
    return {
      popVisible: false,
      lastpage: 0,
      reuters: [
        {
          no: 60,
          isSelect: false,
          isPlatform: '사용',
          isTopic: 'Y',
          isMain: 'OK',
          sendImoocDate: '2021-01-25',
          sendMailDate: '2021-01-25',
          code: 'CKR130947',
          date: '2021-01-22',
          title: 'Norwegian Air gets backing for survival plan',
          tutor: 'Joanne Jang(내부 직원)',
          create_date: '2021-01-22'
        }
      ],
      reuterTables: [],
      sendInfo: [],
      tutors: [],
      videos: [],
      channels: [],
      filter: {
        receiveFl: '',
        sdate: '',
        edate: '',
        sField: 'R_NAME',
        sText: '',
      },
      years: [],
      months: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
      ]
    }
  },
  mounted () {
    this.selectChannels()
  },
  methods: {
    popClose: function () {
      this.popVisible = false
    },
    deleteChannel: function (channelId) {
      if(confirm('삭제 하시겠습니까?')){
        this.selectChannels()
        const url = '/v1/api/admin/pick4u/channels/' + channelId
        this.axios.delete(url)
        .then(res => {
          if (res.data.err === 0) {
            console.log(res)
            this.selectChannels()
          } else {
            alert('삭제에 실패했습니다.')
          }
        }).catch(err => {
          if (err.response.data.path === '/login/msg') {
            alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
            this.$router.push('/login')
          } else {
            alert('관리자에게 문의하세요')
          }
        })
      }
    },    
    goOtherPage(path){
      let route = this.$router.resolve({path});
      window.open(route.href,"_blank");
    },
    clickCallback: function (page) {
      this.filter.page = page
      this.selectChannels()
    },
    selectChannels: function () {
      const url = '/v1/api/admin/pick4u/channels'
      const params = this.getParams({
        sdate: this.filter.sdate
        , edate: this.filter.edate
        , channelName: this.filter.channelName
        , channelId: this.filter.channelId
        , page: this.filter.page
      })
      this.axios.get(url, {
        params: params
      })
      .then(res => {
        if (res.data.err === 0) {
          console.log(res)
          this.result = res.data.result
          this.channels = res.data.result.value
          this.lastpage = res.data.result.lastPage
        }
      }).catch(err => {
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          this.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })
    },
  }
}
</script>

<style>
@import "../../../src/assets/scss/style.css";
@import "../../../src/assets/scss/commons/_style.css";
@import "../../../src/assets/scss/commons/_carrot.css";

tr:hover {
  background-color: #f9fafb;
}
</style>



// WEBPACK FOOTER //
// src/pages/p4u/pick4u.vue